import React, { useState } from 'react';
import { FaStar, FaHeart, FaHome, FaShoppingCart } from 'react-icons/fa';
import PostCard from '../components/PostCard';
import { Helmet } from "react-helmet";

function Home() {
  const [favorites, setFavorites] = useState([]);
  const [notification, setNotification] = useState('');

  const posts = [
    {
      id: 1,
      title: 'Die besten Fahrradrouten in Deutschland fuer 2025',
      excerpt: 'Entdecken Sie atemberaubende Radwege durch malerische Landschaften und historische Staedte. Von der Ostsee bis zu den Alpen bietet Deutschland vielfaeltige Moeglichkeiten fuer unvergessliche Fahrradtouren.',
      image: '/images/1.jpg',
      date: '15. Januar 2025',
      author: 'Anna Schmidt'
    },
    {
      id: 2,
      title: 'E-Bike Revolution: Warum elektrische Fahrraeder die Zukunft sind',
      excerpt: 'E-Bikes revolutionieren die urbane Mobilitaet. Erfahren Sie alles ueber die neuesten Modelle, Technologien und warum immer mehr Menschen auf elektrische Unterstuetzung beim Radfahren setzen.',
      image: '/images/2.jpg',
      date: '12. Januar 2025',
      author: 'Michael Weber'
    },
    {
      id: 3,
      title: 'Fahrradpflege im Winter: Tipps fuer die kalte Jahreszeit',
      excerpt: 'Der Winter stellt besondere Anforderungen an Ihr Fahrrad. Lernen Sie wichtige Wartungstipps kennen, um Ihr Rad sicher durch Schnee und Eis zu bringen und die Lebensdauer zu verlaengern.',
      image: '/images/3.jpg',
      date: '08. Januar 2025',
      author: 'Sarah Mueller'
    },
    {
      id: 4,
      title: 'Urbane Mobilitaet: Fahrradverleih als Alternative zum Auto',
      excerpt: 'Staedtische Mobiliaet neu gedacht. Erfahren Sie, wie Fahrradverleih-Services die Art und Weise veraendern, wie wir uns in der Stadt fortbewegen und zur Reduzierung von Verkehr und Emissionen beitragen.',
      image: '/images/4.jpg',
      date: '05. Januar 2025',
      author: 'Thomas Becker'
    },
    {
      id: 5,
      title: 'Familienradtouren: Die schoensten Strecken fuer Kinder',
      excerpt: 'Gemeinsame Erlebnisse auf zwei Raedern schaffen bleibende Erinnerungen. Entdecken Sie kinderfreundliche Radwege, Sicherheitstipps und wie Sie Radtouren fuer die ganze Familie zum Abenteuer machen.',
      image: '/images/5.jpg',
      date: '02. Januar 2025',
      author: 'Julia Fischer'
    }
  ];

  const handleFavorite = (postId) => {
    if (favorites.includes(postId)) {
      setFavorites(favorites.filter(id => id !== postId));
      showNotification('Aus Favoriten entfernt');
    } else {
      setFavorites([...favorites, postId]);
      showNotification('Zu Favoriten hinzugefuegt');
    }
  };

  const showNotification = (message) => {
    setNotification(message);
    setTimeout(() => setNotification(''), 3000);
  };

  return (
    <>
      <Helmet>
        <title>Tulvod - Ihr Experte fuer urbane Mobilitaet</title>
        <meta name="description" content="Tulvod - Entdecken Sie die besten Tipps, Routen und Informationen rund um Fahrradverleih und urbane Mobilitaet in Deutschland. Ihr Experte fuer Fahrradtouren und nachhaltige Fortbewegung." />
      </Helmet>

      <div>
      <section className="hero-section">
        <div className="hero-content">
          <h1>Willkommen bei Ihrem Fahrradverleih Experten</h1>
          <p>
            Entdecken Sie die Welt auf zwei Raedern mit unserem erstklassigen Fahrradverleih-Service.
            Qualitaet, Komfort und unvergessliche Erlebnisse garantiert.
          </p>
          
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon"><FaStar /></div>
              <h3>Premium Qualitaet</h3>
              <p>Hochwertige Fahrraeder regelmaessig gewartet und auf dem neuesten Stand der Technik fuer Ihre Sicherheit.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon"><FaHeart /></div>
              <h3>Leidenschaft fuer Radfahren</h3>
              <p>Unser Team besteht aus erfahrenen Radfahrern die ihre Begeisterung und ihr Wissen gerne teilen.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon"><FaHome /></div>
              <h3>Lokale Expertise</h3>
              <p>Wir kennen die besten Routen und Geheimtipps in Ihrer Region fuer unvergessliche Touren.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon"><FaShoppingCart /></div>
              <h3>Flexible Angebote</h3>
              <p>Von Stundenvermietung bis Wochenabos bieten wir massgeschneiderte Loesungen fuer jeden Bedarf.</p>
            </div>
          </div>

          <div className="stats-section">
            <div className="stat-item">
              <div className="stat-number">15000+</div>
              <div className="stat-label">Zufriedene Kunden</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">8</div>
              <div className="stat-label">Jahre Erfahrung</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">500+</div>
              <div className="stat-label">Verfuegbare Fahrraeder</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">50+</div>
              <div className="stat-label">Empfohlene Routen</div>
            </div>
          </div>

          
        </div>
      </section>

      <section className="about-blog-section">
        <h2>Ihr umfassender Ratgeber fuer Fahrradverleih und urbane Mobilitaet</h2>
        <p>
          Willkommen auf unserem Blog, der fuehrenden Informationsquelle fuer alles rund um Fahrradverleih,
          Radtouren und nachhaltige Mobilitaet in Deutschland. Seit 2017 bieten wir unseren Lesern fundierte
          Artikel, praktische Tipps und inspirierende Geschichten aus der Welt des Radfahrens. Unser Team
          besteht aus passionierten Radfahrern, Mobilitaetsexperten und Outdoor-Enthusiasten, die ihre
          Erfahrungen und ihr Wissen mit Ihnen teilen moechten.
        </p>
        <p>
          In einer Zeit, in der nachhaltige Fortbewegung immer wichtiger wird, moechten wir Sie dabei
          unterstuetzen, die Freude am Radfahren zu entdecken oder wiederzuentdecken. Ob Sie ein erfahrener
          Radfahrer sind, der neue Herausforderungen sucht, oder ein Einsteiger, der die Grundlagen lernen
          moechte - bei uns finden Sie relevante und aktuelle Informationen. Wir behandeln Themen von der
          Auswahl des richtigen Fahrrads ueber Wartungstipps bis hin zu den schoensten Radrouten in
          Deutschland und Europa.
        </p>
        <p>
          Was unseren Blog besonders macht, ist die Kombination aus praktischer Expertise und
          Begeisterung fuer das Radfahren. Jeder Artikel wird sorgfaeltig recherchiert und von Experten
          geprueft. Wir legen grossen Wert auf Qualitaet, Aktualitaet und die praktische Anwendbarkeit
          unserer Inhalte. Unsere Autoren testen regelmaessig neue Fahrradmodelle, erkunden neue Routen
          und bleiben stets auf dem neuesten Stand der Entwicklungen in der Fahrradbranche und urbanen
          Mobilitaet. Dadurch koennen wir Ihnen authentische Erfahrungsberichte und verlassliche
          Empfehlungen bieten.
        </p>
        <p>
          Neben informativen Artikeln bieten wir auch eine Plattform fuer den Austausch unter
          Gleichgesinnten. In unserer wachsenden Community finden Sie Menschen, die Ihre Leidenschaft
          fuer das Radfahren teilen. Ob Sie Tipps fuer Ihre naechste Tour suchen, Erfahrungen
          austauschen oder einfach nur Inspiration finden moechten - unser Blog ist der richtige Ort
          dafuer. Werden Sie Teil unserer Gemeinschaft und entdecken Sie die vielfaeltigen
          Moeglichkeiten, die das Radfahren bietet.
        </p>
      </section>

      <div className="posts-container">
        <h2>Aktuelle Blogbeitraege</h2>
        <div className="posts-grid">
          {posts.map(post => (
            <PostCard
              key={post.id}
              post={post}
              onFavorite={handleFavorite}
              isFavorite={favorites.includes(post.id)}
            />
          ))}
        </div>
      </div>

      <section className="glossary-section">
        <h2>Glossar - Wichtige Begriffe</h2>
        <div className="glossary-grid">
          <div className="glossary-item">
            <h3>E-Bike</h3>
            <p>Elektrisches Fahrrad mit Tretunterstuetzung bis 25 km/h. Ideal fuer laengere Strecken und huegelige Gebiete.</p>
          </div>
          <div className="glossary-item">
            <h3>Pedelec</h3>
            <p>Pedal Electric Cycle - Fahrrad mit Elektromotor der nur beim Treten unterstuetzt. In Deutschland bis 25 km/h ohne Fuehrerschein fahrbar.</p>
          </div>
          <div className="glossary-item">
            <h3>Bikesharing</h3>
            <p>System zur gemeinschaftlichen Nutzung von Fahrraeder. Flexible Ausleihe und Rueckgabe an verschiedenen Stationen in der Stadt.</p>
          </div>
          <div className="glossary-item">
            <h3>Radweg</h3>
            <p>Speziell fuer Fahrraeder ausgewiesene Verkehrswege. Bieten mehr Sicherheit und Komfort fuer Radfahrer.</p>
          </div>
          <div className="glossary-item">
            <h3>Trekkingrad</h3>
            <p>Vielseitiges Fahrrad fuer lange Touren und taegliche Fahrten. Ausgestattet mit Gepaecktraeger und Schutzblechen.</p>
          </div>
          <div className="glossary-item">
            <h3>Stadtrad</h3>
            <p>Komfortables Fahrrad fuer den urbanen Einsatz. Aufrechte Sitzposition und robuste Ausstattung fuer den Stadtverkehr.</p>
          </div>
        </div>
      </section>

      {notification && (
        <div className="notification">
          {notification}
        </div>
      )}
    </div>
  
    </>);
}

export default Home;